module.exports = __webpack_public_path__ + "static/media/dany_specification.e970a86f.md";